import { render, staticRenderFns } from "./StandardAPIPreview.vue?vue&type=template&id=82b49f92&"
import script from "./StandardAPIPreview.vue?vue&type=script&lang=js&"
export * from "./StandardAPIPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports